import axiosInstance from 'src/services/common/axiosInstance'
import { API_ROUTES } from 'src/services/common/routes'

const getUserMaterialItemPositions = async (userId) => {
  try {
    const url = API_ROUTES.MaterialItemPositions.replace(':user_id', userId)
    const res = await axiosInstance.get(url)
    return res.data
  } catch (error) {
    console.error('Error fetching material item positions:', error)
    throw error
  }
}

export default getUserMaterialItemPositions
